// extracted by mini-css-extract-plugin
export default {"modal-header":"AddHolidayManuallyModal_modal-header__B73d2","form-container-head-warning":"AddHolidayManuallyModal_form-container-head-warning__aqaz3"};